import React from 'react'

import { Typography } from "@mui/material"


export default function lorColumn() {

	return {
		name: 'lor',
		label: 'LOR',
		options: {
			setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRenderLite: value => <Typography>{!!value && value}</Typography>
		}
	}
}